import { render } from "./SharedRelationshipTypeData.vue?vue&type=template&id=675bbad2"
import script from "./SharedRelationshipTypeData.vue?vue&type=script&lang=js"
export * from "./SharedRelationshipTypeData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__